module.exports = __webpack_public_path__ + "static/media/ward.cd4a125f.svg";